export default "__VITE_PUBLIC_ASSET__12282ed1__"